import React from 'react';
import { motion } from 'framer-motion';

const SectionDivider: React.FC = () => {
  return (
    <section className="relative py-16" style={{ backgroundColor: '#2C2721' }}>
      {/* Main animated line */}
      <motion.div
        className="relative mx-auto"
        style={{ width: '80%', height: '2px' }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true, amount: 0.5 }}
      >
        {/* Gradient line */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background: `linear-gradient(90deg, 
              transparent 0%, 
              #F1EFE0 20%, 
              #F1EFE0 50%, 
              #F1EFE0 80%, 
              transparent 100%)`
          }}
        />
        
        {/* Animated glow effect */}
        <motion.div
          className="absolute inset-0 rounded-full blur-sm"
          style={{
            background: `linear-gradient(90deg, 
              transparent 0%, 
              rgba(241, 239, 224, 0.6) 20%, 
              rgba(241, 239, 224, 0.8) 50%, 
              rgba(241, 239, 224, 0.6) 80%, 
              transparent 100%)`,
            transform: 'scaleY(3)'
          }}
          animate={{
            opacity: [0.3, 0.8, 0.3],
            scaleX: [0.8, 1.2, 0.8]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.div>





      {/* Animated particle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(5)].map((_, index) => (
          <motion.div
            key={index}
            className="absolute w-1 h-1 rounded-full"
            style={{ 
              backgroundColor: '#F1EFE0',
              left: `${20 + index * 15}%`,
              top: '50%'
            }}
            animate={{
              y: [-10, 10, -10],
              opacity: [0.2, 0.6, 0.2],
              scale: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 2 + index * 0.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: index * 0.3
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default SectionDivider;